
import { createTheme } from '@mui/material';
import variables from '../../assets/styles/variables.module.scss';

const JAQtheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: variables.color_primary
    },
    secondary: {
      main: variables.color_steel_grey
    },
    error: {
      main: variables.color_red
    },
    success: {
      main: variables.color_green
    },
    warning: {
      main: variables.color_orange
    },
  },
});



const ataiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: variables.color_on_background
    },
    secondary: {
      main: variables.color_on_background
    },
    tertiary: {
      main: variables.color_tertiary
    },
    error: {
      main: variables.color_red
    },
    success: {
      main: variables.color_green
    },
    warning: {
      main: variables.color_orange
    },
  },
});

export const theme = process.env.REACT_APP_SKIN_NAME === 'atai' ? ataiTheme : JAQtheme;